module.exports = __webpack_public_path__ + "img/iPhone 12 Pro Mockup.67003791.png";